import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';

import PortalContainer from '~components/PortalContainer';
import { useToastStore } from '~store/toast';

import { S } from './styles';

function Toast() {
  const { toastList, toastClose } = useToastStore();
  const [timeIds, setTimeIds] = useState<string[]>([]);

  /** Toast 로직 리팩토링 필요 */
  useEffect(() => {
    const toastIds = Array.from(toastList.keys());

    function setTimeoutId(toastId: string) {
      const toast = toastList.get(toastId);

      if (!timeIds.includes(toastId)) {
        setTimeIds((prev) => [...prev, toastId]);
        const timeoutId = setTimeout(() => {
          toastClose(toastId);
        }, toast?.option.duration);

        return () => {
          clearTimeout(timeoutId);
        };
      }

      return;
    }

    if (toastIds.length > 0) {
      toastIds.map((toastId) => {
        setTimeoutId(toastId);
      });
    }
  }, [toastList]);

  return (
    <PortalContainer className='toastContainer'>
      <S.ToastStyle />
      <S.ToastWrapper>
        <AnimatePresence mode={'popLayout'}>
          {Array.from(toastList.values()).map((toast) => (
            <S.StyledToast
              layout
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ type: 'spring' }}
              variant={toast.option?.variant ?? 'default'}
              key={toast.id}>
              <S.Content>
                <div>{toast.option.icon && toast.option.icon}</div>
                <span>{toast.content}</span>
              </S.Content>
            </S.StyledToast>
          ))}
        </AnimatePresence>
      </S.ToastWrapper>
    </PortalContainer>
  );
}

export default Toast;
